import { inject, Injectable, signal } from '@angular/core';
import { Note, NoteResults, Results } from './note.model';
import { map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root',
})
export class NoteStore {
	readonly notesList = signal<Note[]>(null);

	private readonly httpClient = inject(HttpClient);

	loadNotes(resourceID: number): void {
		this.httpClient
			.get(`${environment.apiUrl}/task_note/note/?table_id__in=${resourceID}&limit=999`)
			.pipe(map((result: NoteResults) => result.results))
			.subscribe((notes: Note[]) => {
				this.notesList.set(notes);
			});
	}

	fetchNote(noteID: number): Observable<Note> {
		return this.httpClient.get<Note>(`${environment.apiUrl}/task_note/note/${noteID}/`);
	}
}
